type Relationship = {
	uuid: string;
	label: string;
	value: string;
};

export const relationships: Relationship[] = [
	{
		uuid: "9e686260-4504-4f17-a3f2-a80511825f01",
		label: "Adoptive Father",
		value: "ADOPTIVE FATHER",
	},
	{
		uuid: "9e686260-451a-4e5f-ad5f-3b76b655bc5b",
		label: "Adoptive Mother",
		value: "ADOPTIVE MOTHER",
	},
	{
		uuid: "9e686260-451e-4342-a381-71cb14f19000",
		label: "Aunt",
		value: "AUNT",
	},
	{
		uuid: "9e686260-4523-4a87-8086-0f3d262f34bb",
		label: "Brother-in-Law",
		value: "BROTHER-IN-LAW",
	},
	{
		uuid: "9e686260-4528-4330-9f7a-baf2885688c3",
		label: "Cousin",
		value: "COUSIN",
	},
	{
		uuid: "9e686260-452b-4daa-ad71-14ca9711b8f3",
		label: "Father",
		value: "FATHER",
	},
	{
		uuid: "9e686260-452e-4e9d-a18f-65d4efd78ce0",
		label: "Father-in-Law",
		value: "FATHER-IN-LAW",
	},
	{
		uuid: "9e686260-4530-4a9a-a05c-edb76623afeb",
		label: "Foster Father",
		value: "FOSTER FATHER",
	},
	{
		uuid: "9e686260-4536-4f0d-8169-994266cee7f4",
		label: "Foster Mother",
		value: "FOSTER MOTHER",
	},
	{
		uuid: "9e686260-453a-4932-8b9a-f1d86b55a937",
		label: "Full-Sibling",
		value: "FULL-SIBLING",
	},
	{
		uuid: "9e686260-453d-4f06-8444-7c90a95175ef",
		label: "Godfather",
		value: "GODFATHER",
	},
	{
		uuid: "9e686260-4541-4071-af1a-fa9d71b9a961",
		label: "Godmother",
		value: "GODMOTHER",
	},
	{
		uuid: "9e686260-4545-422b-b0d1-d318849f0439",
		label: "Grandfather",
		value: "GRANDFATHER",
	},
	{
		uuid: "9e686260-4548-4037-b0d8-a922ce98dbb9",
		label: "Grandmother",
		value: "GRANDMOTHER",
	},
	{
		uuid: "9e686260-454b-4457-a670-0e6cb29a8ce7",
		label: "Half-Father",
		value: "HALF-FATHER",
	},
	{
		uuid: "9e686260-454e-46e4-bb7c-ecae284dc005",
		label: "Half-Mother",
		value: "HALF-MOTHER",
	},
	{
		uuid: "9e686260-4551-4d31-b401-45ceb0c3b968",
		label: "Half-Sibling",
		value: "HALF-SIBLING",
	},
	{
		uuid: "9e686260-4553-450e-8cbb-0469995d1b5d",
		label: "Legal Guardian",
		value: "LEGAL GUARDIAN",
	},
	{
		uuid: "9e686260-4616-4b09-a53f-510b0cf097b9",
		label: "Mother",
		value: "MOTHER",
	},
	{
		uuid: "9e686260-461c-4a9a-b31e-14bc3e4422df",
		label: "Mother-in-Law",
		value: "MOTHER-IN-LAW",
	},
	{
		uuid: "9e686260-461f-4fa1-a470-6d1460ee38c9",
		label: "Other",
		value: "OTHER",
	},
	{
		uuid: "9e686260-4622-4c9d-ab2b-c5aa7a796dff",
		label: "Step-Father",
		value: "STEP-FATHER",
	},
	{
		uuid: "9e686260-4626-4785-b835-f20af6e01085",
		label: "Step-Grandfather",
		value: "STEP-GRANDFATHER",
	},
	{
		uuid: "9e686260-4629-4ab7-8661-1b349f101f7a",
		label: "Step-Grandmother",
		value: "STEP-GRANDMOTHER",
	},
	{
		uuid: "9e686260-462e-4a80-9f74-45321a7928ae",
		label: "Step-Mother",
		value: "STEP-MOTHER",
	},
	{
		uuid: "9e686260-4632-4d47-aa6b-a2f6fbbabe69",
		label: "Uncle",
		value: "UNCLE",
	},
];
